
import React, {useEffect} from "react";

import Die from "./components/die"
import {nanoid} from "nanoid"
import Confetti from 'react-confetti'

function App(){

    const gameName = "Match Me"
    const [darkMode, setDarkMode] = React.useState(false)
    const [diceState, setDiceState] = React.useState(generateNums())
    const [tenzies, setTenzies] = React.useState(false)
    const [lockedCount, setLockedCount] = React.useState(0)
    const [rollsCount, setRollsCount] = React.useState(1)

    //Items for local storage
    const currentRollsBest = localStorage.getItem('rollsBest')
    const winsCount = localStorage.getItem('totalWins')
    const [infoModal, setInfoModal] = React.useState(localStorage.getItem("introDismissed"))

    const storedLetters = JSON.parse(localStorage.getItem('completed-letters'));
    if(storedLetters === null){
        const myLetters = {v1: null, v2: null, v3: null, v4: null, v5: null, v6: null}
        localStorage.setItem('completed-letters',JSON.stringify(myLetters))
    }
    const [lettersComplete, setLettersComplete] = React.useState({
        v1:storedLetters.v1,
        v2:storedLetters.v2,
        v3:storedLetters.v3,
        v4:storedLetters.v4,
        v5:storedLetters.v5,
        v6:storedLetters.v6
    })

    //generate 10 random numbers between 1 and 6
    function genRandomNum(){
        return Math.ceil(Math.random() * 6)
    }

    function generateNums(){
        const newDice = []
        for(let i = 0; i < 10; i++) {
            newDice.push({
                id: nanoid(),
                value: genRandomNum(),
                locked: false
            })
        }
        return newDice
    }

    useEffect(() => {
        const allLocked = diceState.every(die => die.locked)
        const sourceDie = diceState[0]
        const currentLetter = 'v'+sourceDie.value
        const allNumsMatch = diceState.every((die, index, arr) => die.value === sourceDie.value);

        if(allLocked && allNumsMatch ) {
            setTenzies(true)

            if (localStorage.getItem("totalWins") === null) {
                localStorage.setItem("totalWins", "1");
            } else {
                localStorage.setItem("totalWins", parseInt(localStorage.getItem("totalWins")) + 1);
            }

            if (currentRollsBest > rollsCount || currentRollsBest === null || currentRollsBest === "-"){
                localStorage.setItem('rollsBest', rollsCount)
            }

            setLettersComplete(prevLetters => {

                const myLetters = {
                    ...storedLetters,
                    [currentLetter]: currentLetter
                }

                localStorage.setItem('completed-letters',JSON.stringify(myLetters))

                return {
                    ...prevLetters,
                    [currentLetter]: true
                }
            })
        }

        const lockedItems = diceState.filter(item => item.locked)

        setLockedCount(function(){
            if(!allNumsMatch && lockedItems.length === 10 ) {
                console.log('hmmmm you have 10 locked but not the same')
                document.querySelector('.dice-container').classList.add('incorrect')
                setTimeout(() => {
                    document.querySelector('.dice-container').classList.remove('incorrect')
                },500)
            }

            const count = {};
            let maxCount = 0;
            for (const item of diceState) {
                if (item.locked === true) {
                    const key = item.locked + '|' + item.value;
                    if (count[key]) {
                        count[key]++;
                    } else {
                        count[key] = 1;
                    }
                    if (count[key] > maxCount) {
                        maxCount = count[key];
                    }
                }
            }
            return maxCount;
        })

    },[diceState])

    const createDice = diceState.map((die, index) => {
        //console.log(die)
        return <Die
            key={index}
            id={die.id}
            value={die.value}
            locked={die.locked}
            toggleDiceLock={toggleDiceLock}
        />
    })


    //========= Click and onChange Handler Functions =========== //

    //Helper function to toggle classname easier
    const toggleClass = (element, className) => {
        if (element.classList.contains(className)) {
            element.classList.remove(className);
        } else {
            element.classList.add(className);
        }
    };

    //Helper function to add ripple effect to buttons
    function rippleEffect(event){
        const button = event.currentTarget;

        const circle = document.createElement("span");
        const diameter = Math.max(button.clientWidth, button.clientHeight);
        const radius = diameter / 2;

        const rect = event.currentTarget.getBoundingClientRect();
        const buttonX = rect.left;
        const buttonY = rect.top;

        circle.style.width = circle.style.height = `${diameter}px`;
        circle.style.left = `${event.clientX - buttonX - radius}px`;
        circle.style.top = `${event.clientY - buttonY - radius}px`;
        circle.classList.add("ripple");

        const ripple = button.getElementsByClassName("ripple")[0];

        if (ripple) {
            ripple.remove();
        }

        button.appendChild(circle);
    }


    function reRollDice(event){

        setDiceState(function(prevDiceState){
            return(
                prevDiceState.map((die) => {
                    return die.locked === true ?
                        {...die} :
                        {...die, value: genRandomNum()}
                })
            )
        })
        setRollsCount(rollsCount + 1)
        toggleClass(event.target,'active')
    }

    function toggleDiceLock(id){
        setDiceState(function(prevDiceState){
            return(
                prevDiceState.map((die) => {
                    return id === die.id ? {...die, locked: !die.locked} : {...die}
                })
            )
        })
    }

    function startNewGame(event){
        setTenzies(false)
        setDiceState(generateNums())
        setRollsCount(1)
        event.target.classList.add('active');
        setTimeout(() => {
            event.target.classList.remove('active');
        }, 300);
    }

    function totalReset(event){
        localStorage.setItem('totalWins', '0')
        localStorage.setItem('rollsBest', '-')
        setLettersComplete(prevState => {
            const myLetters = {v1: null, v2: null, v3: null, v4: null, v5: null, v6: null}
            localStorage.setItem('completed-letters',JSON.stringify(myLetters))
            return {v1: null, v2: null, v3: null, v4: null, v5: null, v6: null}
        })
        event.target.classList.add('active');
        setTimeout(() => {
            event.target.classList.remove('active');
        }, 300);
        startNewGame()
    }

    function toggleDarkMode(){
        setDarkMode(!darkMode)
    }

    function toggleInfoModal(){
        setInfoModal(!infoModal)
        localStorage.setItem("introDismissed", 'dismissed')
    }

    return(
        <div className={`main-wrapper ${darkMode ? "dark-mode" : "light-mode"}`}>
            <div className="scanlines"></div>
            {tenzies && <Confetti className="confetti" />}

            <a href="https://dustinthornborrow.com" target="_blank" className="logo-container">
                {darkMode ? <span className="dark-mode-logo">dt</span> : <img src="images/dt-logo-small.svg" alt=""/>}
            </a>

            <div className="settings">
                <span className="material-icons info-trigger" onClick={toggleInfoModal}>info_outlined</span>

                <label className="toggle" htmlFor="dark-mode-toggle">
                    <input className="toggle-checkbox" type="checkbox" id="dark-mode-toggle" onChange={toggleDarkMode} />
                    <div className="toggle-switch"></div>
                </label>
            </div>

            <div className="logo-blocks">
                <div className="logo-blocks-inner">
                    {lettersComplete.v1 ? <img className="logo-block letter-complete" src="images/LC-1.png" alt="D"/> : <img className="logo-block" src="images/LB-1.png" alt="D"/>}
                    {lettersComplete.v2 ? <img className="logo-block letter-complete" src="images/LC-2.png" alt="U"/> : <img className="logo-block" src="images/LB-2.png" alt="U"/>}
                    {lettersComplete.v3 ? <img className="logo-block letter-complete" src="images/LC-3.png" alt="S"/> : <img className="logo-block" src="images/LB-3.png" alt="U"/>}
                    {lettersComplete.v4 ? <img className="logo-block letter-complete" src="images/LC-4.png" alt="T"/> : <img className="logo-block" src="images/LB-4.png" alt="U"/>}
                    {lettersComplete.v5 ? <img className="logo-block letter-complete" src="images/LC-5.png" alt="I"/> : <img className="logo-block" src="images/LB-5.png" alt="U"/>}
                    {lettersComplete.v6 ? <img className="logo-block letter-complete" src="images/LC-6.png" alt="N"/> : <img className="logo-block" src="images/LB-6.png" alt="U"/>}
                    {/*{Object.values(lettersComplete).every(val => val !== null) && <span className="reset-logo material-icons">rotate_left</span>}*/}
                </div>
            </div>

            <div className="tenzie-container-wrap">
                <main className="tenzie-container">
                    <div className="tenzie-container-nested">
                        {infoModal &&
                            <div className="locked-count">{lockedCount}<span className="count-slash">/</span>10</div>
                        }


                        {!infoModal ?
                            <div className="intro-block text-center">
                                <h1>Welcome to {gameName}!</h1>
                                <div className="mb-30">
                                    Shuffle the symbols until <strong>all 10 are the same</strong>. Click or tap a symbol to lock it between shuffles.
                                    Once you match 10 of the same symbol, the game is won! Use the <span className="intro-icon material-icons" style={{transform: 'translateY(7px)'}}>rotate_left</span><strong>New Round</strong> button to quickly start over, or try for a better first set. Use the <span className="intro-icon material-icons" style={{transform: 'translateY(7px)'}}>rotate_left</span><strong>Reset All</strong> button to reset all saved stats and progress.
                                </div>
                                <div className="button-wrapper">
                                    <button className="button mlr-auto" onClick={(e) => {rippleEffect(e); toggleInfoModal();}}>Got it!</button>
                                </div>
                            </div>
                        :
                            <div className="tenzie-inner">
                                <div className="dice-container">
                                    {createDice}
                                </div>
                                <div className="controls">
                                    <div className="button-wrapper">
                                        {tenzies ? <button className="button play-again-btn" onClick={(e) => {rippleEffect(e); startNewGame();}}><span className="btn-icon material-icons md-24">restart_alt</span> Play Again</button>
                                            : <button className="button shuffle-btn" onClick={(e) => {rippleEffect(e); reRollDice(e);}}><span className="btn-icon material-icons md-24">shuffle</span> Shuffle Symbols</button>
                                        }
                                    </div>
                                    <div className="flex flex-ai-center mt-15 link-text reset-btn" onClick={startNewGame}>
                                        <span className="btn-icon material-icons">rotate_left</span> New Round
                                    </div>
                                </div>
                            </div>
                        }

                        {infoModal &&
                            <div className="stats-block">
                                <div className="stats stat-rolls"><span className="stat-label">Shuffles</span><span className="stat-value">{rollsCount}</span></div>
                                <div className="stats stat-best"><span className="stat-label">Best Round</span><span className="stat-value">{currentRollsBest ? currentRollsBest : "-"}</span></div>
                                <div className="stats stat-wins"><span className="stat-label">Total Wins</span><span className="stat-value">{winsCount !== null ? winsCount : 0}</span></div>
                                <div className="total-reset mt-10 flex flex-ai-center link-text" data-tooltip="This will reset all saved stats and progress" onClick={totalReset}><span className="btn-icon material-icons">rotate_left</span>Reset All</div>
                            </div>
                        }

                    </div>
                </main>
            </div>
        </div>
    )
}
export default App